<div class="loading-container">
  <div class="logo-wrapper">
    <div class="spinner"></div>
    <app-brand-logo></app-brand-logo>
  </div>
</div>
